<template>
    <div class="columns">
        <div class="column">
            <div class="level">
                <div class="level-left">
                    <div class="title">Your profile</div>
                </div>
            </div>
            <div class="is-12">
                <!-- basic information -->
                <form novalidate @submit.prevent="submitForm">
                    <div class="level">
                        <div class="column is-6 padding-left-0">
                            <h6 class="subtitle is-12 has-text-weight-bold">Basic information</h6>
                            <div class="field">
                                <label for="first_name" class="label">First name</label>
                                <div :class="[{ 'is-loading': sending}, 'control']">
                                    <input :disabled="sending" id="first_name" class="input" name="first_name" type="text" v-model="form.first_name">
                                </div>
                                <p class="help is-danger" v-if="form.errors.has('first_name')" v-text="form.errors.get('first_name')"></p>
                            </div>
                            <div class="field">
                                <label for="last_name" class="label">Last name</label>
                                <div :class="[{ 'is-loading': sending}, 'control']">
                                    <input :disabled="sending" id="last_name" class="input" name="last_name" type="text" v-model="form.last_name">
                                </div>
                                <p class="help is-danger" v-if="form.errors.has('last_name')"  v-text="form.errors.get('last_name')"></p>
                            </div>
                            <div class="field">
                                <label for="last_name" class="label">Mobile number</label>
                                <div :class="[{ 'is-loading': sending}, 'control']">
                                    <input :disabled="sending" id="mobile_number" class="input" name="mobile_number" type="text"
                                           v-model="form.mobile_number">
                                </div>
                                <p class="help is-danger" v-if="form.errors.has('mobile_number') && form.mobile_number.length !== 0"
                                   v-text="form.errors.get('mobile_number')"></p>
                            </div>
                            <div class="field">
                                <label for="email" class="label">Email address</label>
                                <div :class="[{ 'is-loading': sending}, 'control']">
                                    <input id="email" class="input" name="email" type="text" :value="email" disabled>
                                </div>
                            </div>
                            <div class="column"></div>
                            <div class="column has-text-right is-paddingless">
                                <button id="submitButton" :disabled="disableBtn" type="submit" :class="[{ 'is-loading': sending}, 'button solid-btn']">SAVE CHANGES</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    /* eslint-disable indent,no-new,no-undef */
    import ApiResource from '../api/ApiResource'
    import misc from '../mixins/misc.js'

    export default {
        metaInfo: {
            title: 'Business Portal | Hellopeter - Your profile'
        },
        mounted () {
            this.$gtm.trackEvent({
                event: 'pageLoad',
                virtualPageUrl: this.$router.currentRoute.path,
                virtualPageTitle: 'Your profile'
            })
        },
        mixins: [misc],
        data () {
            return {
                sending: true,
                email: '',
                initials: '',
                original: {
                    first_name: '',
                    last_name: '',
                    mobile_number: ''
                },
                updateSuccess: false,
                form: new ApiResource({
                    first_name: '',
                    last_name: '',
                    email: '',
                    mobile_number: ''
                })
            }
        },
        created () {
            this.getMyProfile()
        },
        computed: {
            disableBtn () {
                return this.canDisableSubmitBtn(this.sending, this.original, this.form)
            }
        },
        methods: {
            getMyProfile () {
                this.form.send(`/me`, {}, 'get')
                    .then(() => {
                        this.email = this.form.email
                        this.sending = false
                        this.original.first_name = this.form.first_name
                        this.original.last_name = this.form.last_name
                        this.original.mobile_number = this.form.mobile_number
                    })
            },
            submitForm () {
                this.sending = true
                this.updateSuccess = false
                this.form.send(`/me`, {
                    first_name: this.form.first_name,
                    last_name: this.form.last_name,
                    mobile_number: this.form.mobile_number
                }, 'patch')
                    .then(() => {
                        this.updateSuccess = true
                        this.sending = false
                        this.original.first_name = this.form.first_name
                        this.original.last_name = this.form.last_name
                        this.original.mobile_number = this.form.mobile_number

                        if (!this.original.mobile_number) {
                          new ApiResource({}).send(`/me/notifications`, {
                            receive_sms: 0,
                            business_id: parseInt(localStorage.getItem('org_id'))
                          }, 'patch')
                        }

                        localStorage.setItem('mobile_number', this.form.mobile_number)
                        localStorage.setItem('first_name', this.form.first_name)
                        localStorage.setItem('last_name', this.form.last_name)
                        window.events.$emit('profileUpdated')
                        flash('Your profile updated successfully.')
                    })
                    .catch(() => {
                        this.sending = false
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Profile.vue